<template>
  <div>
    <h2 class="text-center">List of College Admins</h2>
    <button
      class="btn-primary bg-green border-none inline-block leading-snug
             px-4 py-2 text-white my-2 hover:bg-green-900 rounded-full
             no-underline"
      @click="new_admin"
    >
      New Admin
    </button>
    <Table ref="myTable" :endpoint="endpoint" :tableConfig="tableConfig" />
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import Table from "@/components/DataTable/Table"

export default {
  components: { Table },
  props: {
    userRole: {
      type: String,
      default: "college_admin",
    },
  },
  data() {
    return {
      endpoint: `${siteConfig.siteURL}users/list?role=${this.userRole}`,
      tableConfig: [
        {
          header: { textContent: "Email" },
          path: "email",
        },
        {
          header: { textContent: "Name" },
          path: "full_name",
        },
        {
          header: { textContent: "Cohorts" },
          path: "get_cohorts_is_admin",
          formatter: cohorts =>
            cohorts
              .map(c => `<span class="cohort-name">${c.name}</span>`)
              .join(" "),
        },
        {
          header: { textContent: "Option" },
          path: "email",
          type: "button",
          buttonText: "Edit",
          onclick: email => {
            this.edit_admin(email)
          },
        },
      ],
    }
  },

  methods: {
    new_admin() {
      this.$emit("add_admin")
    },

    edit_admin(email) {
      this.$emit("edit_admin", email)
    },
  },
}
</script>

<style>
.cohort-name {
  padding: 4px;
  background-color: #ddd;
}
</style>
